// Import from NPM
// -------------------------------------
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// Import App Configuration and Setup
// -------------------------------------
import { Store } from "backend/storage/app.store";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

// Import App
// -------------------------------------
import App from "./app/app";

ReactDOM.render(
    <Provider store={Store} key="provider">
        <App />
    </Provider>,
    document.getElementById("root")
);

registerServiceWorker();
